<!-- eslint-disable max-lines -->
<template>
    <paper class="net-task transport-order-manage">
        <div class="tooltip">
            因审计合规需要，平台需对涉及用户隐私的关键字段（包括但不限于姓名、身份证号、手机号、详细地址等）进行统一脱敏处理。</div>
        <m-pane
            ref="tablePage"
            :config="config"
            :pageTotal="pageTotal"
            :loading="loading"
            :totalData="totalData"
            :searchTotalTitle="config.searchTotalTitle"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @row-db-click="rowDBclick"
            @changeAddress-btn="changeAddress"
            @onReveal-btn="onReveal"
        >
            <div slot="table-module-btn">
                <template v-if="showEye">
                    <el-tooltip effect="dark" content="整页解密" placement="bottom">
                        <el-button class="mgr-10" icon="el-icon-view" size="mini" :disabled="pageTotal === 0" @click="onRevealAll"></el-button>
                    </el-tooltip>
                </template>
                <reportExport
                    #default="{ submit }"
                    reportCode="REPORT_OTP_WAYBILL_CENTER"
                >
                    <el-tooltip effect="dark" content="导出" placement="bottom">
                        <span v-has="'otp04030002'" class="mgl-10">
                            <el-button
                                icon="icon-daochu"
                                size="mini"
                                @click="exportFile(submit)"
                            ></el-button>
                        </span>
                    </el-tooltip>
                </reportExport>
            </div>
            <div slot="page-module-btn">
                <el-button
                    type="primary"
                    @click="issuePlatformBtn"
                    v-has="'04030003'"
                    >下发零担平台</el-button
                >
                <el-button
                    type="primary"
                    @click="revocationPlatformBtn"
                    v-has="'04030004'"
                    >撤销零担平台</el-button
                >
            </div>
        </m-pane>
        <change-address-dialog
            ref="changeAddress"
            v-if="visiable"
            :visiable.sync="visiable"
            :taskNo="taskNo"
            @save="save"
            @handleClose="handleClose"
        >
        </change-address-dialog>
        <issue-platform-dialog
            ref="issuePlatformDialog"
            v-if="visiableDialog"
            :visiableDialog.sync="visiableDialog"
            :selected="selected"
            @issuePlatformOk="issuePlatformOk"
            @handleClose="handleClose"
        >
        </issue-platform-dialog>
        <revocation-platform-dialog
            ref="revocationPlatformDialog"
            v-if="revocationVisiable"
            :revocationVisiable.sync="revocationVisiable"
            :selected="selected"
            @revocationPlatformOk="revocationPlatformOk"
            @handleClose="handleClose"
        >
        </revocation-platform-dialog>
    </paper>
</template>

<script>
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

import mPane from '@/components/otpPanel';
import paper from '@/components/core/paper/Paper';
import reportExport from '@/components/lots/reportExportPlugin';
import config from './config.js';
import formatTime from '@/utils/common.js';
import { transportData, getTotalCounts, saveInformationSecurityLog } from '../../../../api/transportDetails';
import changeAddressDialog from './changeAddressDialog';
import dayjs from 'dayjs';
import { mapState } from 'vuex';
import { dictWithUrl } from '@/components/lots/api.js';
import issuePlatformDialog from './component/issuePlatformDialog';
import revocationPlatformDialog from './component/revocationPlatformDialog';
import { reveal, batchReveal } from './util.js';

export default {
    name: 'transportPage',
    components: { paper, mPane, changeAddressDialog, reportExport, issuePlatformDialog, revocationPlatformDialog },
    data () {
        return {
            config,
            pageTotal: 0,
            loading: false,
            selected: [],
            totalData: [],
            searchParams: {
                pageSize: 10,
                pageNo: 1
            },
            visiable: false,
            exportParams: {},
            isFirstSearch: true,
            taskNo: '',
            visiableDialog: false,
            revocationVisiable: false,
            aesKey: 'deg;LKJU1234++=-',
            showEye: false // 是否显示整页解密眼睛
        };
    },
    methods: {
        _validateSearchParams (data) {
            this._validateFailed = false;
            const beginDate = dayjs(data.beginDate).valueOf() || 0;
            const endDate = dayjs(data.endDate).valueOf() || 0;
            const differenceValue = endDate - beginDate;
            const maxDay63 = 1000 * 60 * 60 * 24 * 32;
            if (!data.customerOrderNo && !data.beginDate) {
                this.$message.warning('客户订单号 和 创建时间 不可同时为空');
                this._validateFailed = true;
            }
            if (data.siteNameList && data.siteNameList.length > 5) {
                this.$message.warning('服务平台最多支持查询5个');
                this._validateFailed = true;
            }
            if (differenceValue > maxDay63) {
                this.$message.warning('按时间查询或导出时，查询或导出时间跨度不可超过一个月！');
                this._validateFailed = true;
            }
        },
        searchChange (data) {
            const normalizeTime = (times, startKey, endKey) => {
                try {
                    const [startTime, endTime] = times || [];
                    data[startKey] = startTime ? formatTime.formatDateTime(startTime) : ''
                    data[endKey] = endTime ? formatTime.formatDateTime(endTime) : ''
                } catch(err) {
                    console.error(err);
                }
            };

            if (data.createTime && data.createTime.length > 0) {
                data.beginDate = formatTime.formatDateTime(data.createTime[0]);
                data.endDate = formatTime.formatDateTime(data.createTime[1]);
            } else if (!data.createTime) {
                data.beginDate = '';
                data.endDate = '';
            }
            if (data.siteName) {
                data.siteNameList = data.siteName.length ? data.siteName.split(',') : [];
                data.siteCodeList = data.siteCode.length ? data.siteCode.split(',') : [];
            } else {
                data.siteNameList = [];
                data.siteCodeList = [];
            }

            normalizeTime(data.requireCarArriveTime, 'requireCarArriveTimeStart', 'requireCarArriveTimeEnd');
            normalizeTime(data.requireDepartTime, 'requireDepartTimeStart', 'requireDepartTimeEnd');
            normalizeTime(data.requireArriveTime, 'requireArriveTimeStart', 'requireArriveTimeEnd');
            normalizeTime(data.requestSignDate, 'requestSignDateStart', 'requestSignDateEnd');

            delete data.siteName;
            delete data.siteCode;
            delete data.createTime;
            delete data.requireCarArriveTime;
            delete data.requireDepartTime;
            delete data.requireArriveTime;
            delete data.requestSignDate;

            this._searchData = data;
            this._validateSearchParams(this._searchData);
            if (this._validateFailed) return false;
            this.searchParams = {
                ...this.searchParams,
                ...data,
                pageNo: 1
            };
            this.searchParams['carrierCode'] = this.supplier.supplierCode;
            for (const key in this.searchParams) {
                if (!this.searchParams[key]) {
                    delete this.searchParams[key];
                }
            }
            this.exportParams = { ...this.searchParams };
            this.getList();
            this.isFirstSearch = false;
        },
        async getList (searchCountFlag = false) {
            // eslint-disable-next-line max-len
            const dict = await dictWithUrl('TRANSPORT_STATUS,ORDER_TYPE,TASK_TYPE,DELIVERY_TYPE,DELIVERED_VERIFY_FLAG,PROJECT_CLASSIFY,BUSINESS_CATEGORY,SOURCE_SYSTEM,OTP_TMS_PROCUREMENT_CHANNEL,TMS_SHIPPING_TYPE,PICK_UP_STATUS,APPOINTMENT_TYPE,HANDLING_STATUS,TMS_VIP_FLAG,OMS_PARAMS_ENTITY_ID,DEVICETYPE,AES_KEY');
            const dictData = dict.data;
            this.aesKey = dictData.AES_KEY.encrypt_key || 'deg;LKJU1234++=-';
            this.loading = true;
            const params = { ...this.searchParams };
            const res = await transportData(params).finally(() => { this.loading = false; });

            if (res && +res.code === 0) {
                this.totalData = res.data.list || [];
                this.totalData.forEach(item => {
                    item.carrierVisibleFlagName = item.carrierVisibleFlag === 'Y' ? '是' : '否';
                    item.sourceSystemName = dictData.SOURCE_SYSTEM[item.sourceSystem] || item.sourceSystem;
                    item.businessCategoryName = dictData.BUSINESS_CATEGORY[item.businessCategory] || item.businessCategory;
                    item.procurementChannelName = dictData.OTP_TMS_PROCUREMENT_CHANNEL[item.procurementChannel] || item.procurementChannel;
                    item.taskStatusName = dictData.TRANSPORT_STATUS[item.taskStatus] || item.taskStatus;
                    item.orderTypeName = dictData.ORDER_TYPE[item.orderType] || item.orderType;
                    item.deliveryTypeName = dictData.DELIVERY_TYPE[item.deliveryType] || item.deliveryType;
                    item.taskTypeName = dictData.TASK_TYPE[item.taskType] || item.taskType;
                    item.snAppointmentTypeName = dictData.APPOINTMENT_TYPE[item.snAppointmentType] || item.snAppointmentType;
                    item.distributionFlagName = item.distributionFlag === 'Y' ? '是' : '否';
                    item.b2cZpFlagName = +item.b2cZpFlag === 1 ? '是' : +item.b2cZpFlag === 0 ? '否' : '';
                    item.distributionContinueFlagName = item.distributionContinueFlag === 'Y' ? '是' : '否';
                    item.deliveredVerifyFlagName = dictData.DELIVERED_VERIFY_FLAG[item.deliveredVerifyFlag] || item.deliveredVerifyFlag;
                    item.projectClassifyName = dictData.PROJECT_CLASSIFY[item.projectClassify] || item.projectClassify;
                    item.shippingTypeName = dictData.TMS_SHIPPING_TYPE[item.shippingType] || item.shippingType;
                    item.deliverypayTypeName = +item.deliverypayType === 2 ? '到付' : '寄付';
                    item.collectionFlagName = item.collectionFlag === 'Y' ? '是' : '否';
                    item.defineStr1TianMaoName = (item.kaType === 'OFC_TMALL' || item.kaType === 'OFC_SUNING') ? item.defineStr1 : ''; // 天猫/苏宁预约单号 kaType === 'OFC_TMALL' || 'OFC_SUNING' 时 展示
                    if (+item.taskStatus >= 40) {
                        item.hiddenEvent = ['changeAddress'];
                    } else {
                        item.hiddenEvent = [];
                    }
                    item.billStatusName = +item.billStatus === 0 ? '已下发' : +item.billStatus === 1 ? '已撤销' : '未下发';
                    item.orderDistinctionFlagName = item.orderDistinctionFlag !== 'CP' ? '是' : '否'; // 是否基地
                    item.pickUpStatusName = dictData.PICK_UP_STATUS[item.pickUpStatus] || item.pickUpStatus;
                    item.handlingStatusName = dictData.HANDLING_STATUS[item.handlingStatus] || item.handlingStatus; // 是否提供装卸服务
                    item.vipFlagName = dictData.TMS_VIP_FLAG[item.vipFlag] || item.vipFlag; // VP客户标识
                    item.entityIdName = dictData.OMS_PARAMS_ENTITY_ID[item.entityId] || item.entityId; // 事业部
                    item.deviceTypeName = dictData.DEVICETYPE[item.deviceType] || item.deviceType; // 设备类型
                    item.qtyItemLoadedCopy = item.qtyItemLoaded; // 数量
                    item.totalQtyCopy = item.totalQty; // 总数量
                    item.totalVolumeCopy = item.totalVolume; // 体积(m³)
                    item.totalGrossWeightCopy = item.totalGrossWeight; // 重量（kg）
                    item.desensitizationFlag = !!item.encryptParam;
                });
                this.showEye = this.totalData.some(v => v.desensitizationFlag);
                if (!searchCountFlag) { this.getPageTotal(); }
            }
        },

        /**
         * 行脱敏数据回显:
         * 1、当行解密
         * 2、相同行解密：收货人+收货人手机+收货详细地址, 以上述三组信息作为判定依据，只要匹配到三组信息一致的，则解密该行数据
         *  */
        onReveal (row) {
            const compareKeys = ['receiverName', 'receiverMobile', 'receiverDetailAddr'];
            reveal(row, this.config, this.aesKey).radiate(this.totalData, compareKeys, this.aesKey).done(donedArr => {
                if (donedArr) {
                    this.totalData = [].concat(this.totalData); // 触发表格更新
                    this.sendRevealLog(donedArr);
                }
            });
        },
        // 整页脱敏数据回显
        onRevealAll () {
            batchReveal(this.totalData, this.config, this.aesKey).done(donedArr => {
                if (donedArr) {
                    this.totalData = [].concat(this.totalData); // 触发表格更新
                    this.sendRevealLog(donedArr);
                }
            });
        },
        // 发送解密日志
        sendRevealLog(rows) {
            if (rows && rows.length) {
                return saveInformationSecurityLog({
                    dataCodeList: [...new Set(rows.map(item => item.taskNo))],
                    pageCode: 'lsp-transport-page', // 运单中心页面标识
                    createUserCode: this.user.userCode
                });
            }
        },
        async getPageTotal () {
            const totalCountRes = await getTotalCounts(this.searchParams);
            this.pageTotal = totalCountRes ? totalCountRes.data : 10000;
        },
        pageChange (data) {
            this.searchParams.pageNo = data;
            this.getList(true);
        },
        sizeChange (data) {
            this.searchParams.pageSize = data;
            this.getList(true);
        },
        selectChange (data) {
            this.selected = data;
        },
        rowDBclick (row) {
            this.$router.push({
                query: { taskNo: row.taskNo },
                path: '/otp/distribute/transport-details'
            });
        },
        exportFile (submit) {
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            !this.isFirstSearch && this._validateSearchParams(this._searchData);
            if (this._validateFailed) return false;
            submit({ ...this.exportParams, tenantCode: this.currentTenant.tenantCode, requestResults: this.$refs.tablePage.tableList });
            this.isFirstSearch = false;
        },
        changeAddress (data) {
            this.taskNo = data.taskNo;
            this.visiable = true;
        },
        save () {
            this.visiable = false;
            this.getList();
        },
        issuePlatformOk () {
            this.visiableDialog = false;
            this.getList();
        },
        revocationPlatformOk () {
            this.revocationVisiable = false;
            this.getList();
        },
        handleClose () {
            this.visiable = false;
            this.visiableDialog = false;
            this.revocationVisiable = false;
        },
        issuePlatformBtn () {
            if (!this.selected.length) { return this.$message.warning('请先勾选单据！'); }
            let taskStatus = false;
            let siteCode = false;
            let orderType = false;
            let billStatus = false;
            this.selected.forEach(item => {
                if (item.siteCode !== this.selected[0].siteCode || item.carrierCode !== this.selected[0].carrierCode) {
                    siteCode = true;
                }
                if (item.taskStatus < 30) {
                    taskStatus = true;
                }
                if (!['YS', 'PO', 'DO'].includes(item.orderType)) {
                    orderType = true;
                }
                if (+item.billStatus === 0) {
                    billStatus = true;
                }
            });
            if (siteCode) {
                return this.$message.warning('存在不同的服务平台/供应商！');
            }
            if (taskStatus) {
                return this.$message.warning('只有运输单状态为待装车后才可以下发!');
            }
            if (billStatus) {
                return this.$message.warning('存在已下发零担平台的订单!');
            }
            if (orderType) {
                return this.$message.warning('只有订单类型为纯运输订单/销售出库/分拨单才可下发!');
            }
            this.visiableDialog = true;
        },
        revocationPlatformBtn () {
            let billStatus = false;
            let externalType = false;
            if (!this.selected.length) { return this.$message.warning('请先勾选单据！'); }
            this.selected.forEach(item => {
                if (+item.billStatus !== 0) {
                    billStatus = true;
                }
                if (item.externalType !== this.selected[0].externalType) {
                    externalType = true;
                }
            });
            if (billStatus) {
                return this.$message.warning('只有已下发零担平台的订单才可以撤销!');
            }
            if (externalType) {
                return this.$message.warning('存在不同的对接平台！');
            }
            this.revocationVisiable = true;
        }
    },
    computed: {
        ...mapState({
            supplier: state => state.supplier,
            currentTenant: state => state.currentTenant,
            user: state => state.user
        })
    }
};
</script>
<style lang="less">
.transport-order-manage{
    .tooltip {
        color: red;
        font-size: 13px;
        padding-bottom: 6px;
    }
    .otp-table {
        .el-table {
            min-height: calc(~'100vh - 192px') !important;
            max-height: calc(~'100vh - 192px') !important;
        }
    }
    .mgr-10{
        margin-right: 10px;
    }
}
</style>
